const $ = require("jquery");
const AOS_animation = require('../../components/AOS-animation/AOS-animation.script');
const FV = require('../../components/form-validation/form-validation.script');
const contatoService = require("../../../services/contact")
const swal = require('sweetalert')
export async function load() {

    $('.abre-modal').on('click', function() {
        var modal = $(this).data('modal');
        $('body').addClass('blocked');
        $('.modal-overlay').addClass('modal-open')
        $(modal).addClass('show-modal');
    })
    $('.modal .close').on('click', function() {
        $('.modal').removeClass('show-modal');
        $('.modal-overlay').removeClass('modal-open')
        $('body').removeClass('blocked');
    })

    $('.modal-overlay').on('click', function() {
        $('.modal').removeClass('show-modal');
        $('.modal-overlay').removeClass('modal-open')
        $('body').removeClass('blocked');
    })

    const formEl_formONG = document.getElementById('formONG');
    const formEl_formEmpresa = document.getElementById('formEmpresa');
    const formEl_form_formPF = document.getElementById('form_formPF');
    await startForm(formEl_formONG, 'ong', "scroll_ong");
    await startForm(formEl_formEmpresa, 'pj', "scroll_pj");
    await startForm(formEl_form_formPF, 'pf', "scroll_pf");
    await FV.addMasksToView(formEl_formONG);
    await FV.addMasksToView(formEl_formEmpresa);
    await FV.addMasksToView(formEl_form_formPF);
    try {
        // await rellax.start('.rellax');
        // await carroucel.start();
        await AOS_animation.start();


        return true
    } catch (err) {
        console.log('err', err)
        return err
    }
}




function startForm(formEl, type, scrollId) {
    formEl
        .addEventListener('submit', function(evt) {
            evt.preventDefault()
            FV.clearErrosMessages(formEl)
            sendForm(formEl, type, scrollId)
        })
}

async function sendForm(formEL, type, scrollID) {

    if (FV.thisFormIsValid(formEL)) {
        const formValues = await FV.getFormValues(formEL);

        // let params = new URLSearchParams(formValues).toString();
        // window.barba.go(`/cadastro/etapa_2?${params}`);
        console.log('formValues', formValues)
        console.log('type', type)
        if (formValues['terms'] == 'on') {
            formValues['terms'] = 'yes'
        } else {
            formValues['terms'] = 'no'
        }

        try {
            await contatoService.sendContact(type, formValues)
            swal("Contato enviado com sucesso", "", "success");
            $('.modal').removeClass('show-modal');
            $('.modal-overlay').removeClass('modal-open')
            $('body').removeClass('blocked');
            $('form').each(function(){
                this.reset();
            });
        } catch (err) {
            swal(err, "", "error");
        }

    } else {
        try {
            const element = document.getElementById(scrollID);
            element.scrollIntoView()
        } catch (err) {
            console.log('err', err)
        }
    }
}
